import { Avatar, Button, Chip, Icon, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { logoutUser } from 'app/auth/store/userSlice';
import { GoogleLogout } from 'react-google-login';
import { AuthType, OAUTH2_ID, AUTH_TYPE_KEY } from 'app/util/consts'
import { getCookie } from 'app/util/utils'
import { useTranslation } from 'react-i18next';
import { showLoading, hideLoading } from 'app/store/fuse/loadingSlice';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    avatar: {
        objectPosition: '50% 0'
    }
}));
function UserMenu(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector(({ auth }) => auth.user);
    const authType = parseInt(getCookie(AUTH_TYPE_KEY));
    const { t } = useTranslation('fuse-layout');

    const [userMenu, setUserMenu] = useState(null);

    const userMenuClick = event => {
        setUserMenu(event.currentTarget);
    };

    const userMenuClose = () => {
        setUserMenu(null);
    };

    const logout = () => {
        dispatch(showLoading({ onBody: true }));
        dispatch(logoutUser());
        userMenuClose();
    }

    const logoutItem = _props =>
        <MenuItem onClick={logout} {..._props}>
            <ListItemText primary={t('userMenu.signOut')} />
        </MenuItem>

    return (
        <>
            <Button className="min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6" onClick={userMenuClick}>
                {user.data.photoURL ? (
                    <Avatar classes={{ img: classes.avatar, root: "mx-4" }} alt="user photo" src={user.data.photoURL} />
                ) : (
                    <Avatar className="md:mx-4">{user.data.displayName[0]}</Avatar>
                )}
            </Button>

            <Popover
                open={Boolean(userMenu)}
                anchorEl={userMenu}
                onClose={userMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                classes={{
                    paper: 'py-8'
                }}
            >
                <MenuItem component={Link} to="/profile" onClick={userMenuClose} role="button" className="text-gray-500">
                    <ListItemIcon className="min-w-40">
                        <Icon className="text-gray-500">account_circle</Icon>
                    </ListItemIcon>
                    <div>{user.data.displayName}</div>
                </MenuItem>
                {authType === AuthType.USERNAME_AND_PASSWORD && logoutItem({})}
                {authType === AuthType.GOOGLE &&
                    <GoogleLogout
                        render={renderProps => logoutItem({ onClick: renderProps.onClick, disabled: renderProps.disabled })}
                        clientId={OAUTH2_ID}
                        buttonText={t('userMenu.signOut')}
                        onLogoutSuccess={logout}
                        onFailure={() => dispatch(hideLoading({ onBody: true }))}
                    >
                    </GoogleLogout>
                }
            </Popover>
        </>
    );
}

export default UserMenu;
